import OneSignal from 'onesignal-cordova-plugin';
import vars from 'src/utils/vars';

export function setupLibraries(): void {
  console.log('Setting up OneSignal');

  if (vars.ONESIGNAL_APP_ID) {
    OneSignal.initialize(vars.ONESIGNAL_APP_ID);

    OneSignal.Notifications.addEventListener('click', async (e) => {
      const clickData = await e.notification;
      console.log('Notification Clicked : ' + clickData);
    });
  }
}
